import React,{useState,useEffect} from 'react'
import FetchApi from '../customhooks/functionFetchApi';
import Spinner from 'react-bootstrap/Spinner';
import { FaFileSignature, FaSearch, FaList, FaCheck, FaClock } from "react-icons/fa";
import Tablejournallistrecieved from './components/componentjournallistrecieved/tablejournallistrecieved';

const isReady = (item) => Number(item.statusConfirm) === 1 && !(item.QuarityStatus > 0);
const isWaitConfirm = (item) => Number(item.statusConfirm) !== 1;
const isWaitQARD = (item) => item.QuarityStatus > 0;

const filters = [
  { key: 'all', label: 'เอกสารทั้งหมด', icon: FaList, match: () => true },
  { key: 'ready', label: 'พร้อมรับงาน', icon: FaCheck, match: isReady },
  { key: 'waitConfirm', label: 'รอ confirm job', icon: FaClock, match: isWaitConfirm },
  { key: 'waitQARD', label: 'รอตรวจสอบ QA/RD', icon: FaSearch, match: isWaitQARD },
];

const Journallistconfirmproduct = () => {
  const FetchApis = new FetchApi();
  const codes = sessionStorage.getItem('EmCode')

  const [loading, setLoading] = useState(false);
  const [journals, setJournals] = useState([])
  const [searchText, setSearchText] = useState('')
  const [activeFilter, setActiveFilter] = useState('all')

  // loading
  useEffect(() => {
      getlistjournal();
  }, [])

  const getlistjournal = () => {
      setLoading(true)

      setTimeout(() => {
          FetchApis.FethcGet(`/journal/getjournalConfirmProduct/${codes}`).then((res) => {

              if (res.status = 200) {
                  setJournals(res.data.data);

                  setLoading(false);
              }

          })
      }, 1000);
  }

  // กรองตามการ์ดที่เลือก + ค้นหาจากทุก field ของรายการ
  const currentFilter = filters.find((f) => f.key === activeFilter);
  const keyword = searchText.trim().toLowerCase();
  const journalList = journals.filter((item) =>
      currentFilter.match(item) &&
      Object.values(item).join(' ').toLowerCase().includes(keyword)
  )

  const cardStyle = (active) => ({
      cursor: 'pointer',
      backgroundColor: active ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.15)',
      border: active ? '1px solid #fff' : '1px solid rgba(255,255,255,0.3)',
      borderRadius: 12,
      padding: '10px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      minWidth: 160,
      transition: 'background 0.2s',
  });

  const iconBoxStyle = {
      backgroundColor: 'rgba(255,255,255,0.25)',
      borderRadius: 8,
      padding: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  };

  return (
      <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh' }}>

          {/* Header */}
          <div style={{
              background: 'linear-gradient(135deg, #1a7f5a 0%, #28B463 100%)',
              padding: '16px 24px 20px',
              boxShadow: '0 3px 10px rgba(0,0,0,0.15)',
          }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                  <div>
                      <div style={{ color: '#fff', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
                          <FaFileSignature /> รายการเอกสาร confirm product
                      </div>
                      <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 13, marginTop: 3 }}>
                          แสดง {journalList.length} จาก {journals.length} รายการ · confirm job แล้วขึ้นก่อน เรียงจากเก่าไปใหม่
                      </div>
                  </div>

                  {/* Search */}
                  <div style={{ position: 'relative', marginTop: 4 }}>
                      <FaSearch style={{
                          position: 'absolute', left: 11, top: '50%',
                          transform: 'translateY(-50%)', color: '#aaa', fontSize: 13,
                      }} />
                      <input
                          type='text'
                          name='TextSearch'
                          placeholder='ค้นหา TDS code, ลูกค้า, สินค้า...'
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          style={{
                              paddingLeft: 34, paddingRight: 14, paddingTop: 8, paddingBottom: 8,
                              borderRadius: 20, border: 'none', fontSize: 13,
                              outline: 'none', width: 260,
                              boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                              color: '#333',
                          }}
                      />
                  </div>
              </div>

              {/* Stat Cards */}
              <div style={{ display: 'flex', gap: 12, marginTop: 16, flexWrap: 'wrap' }}>
                  {filters.map(({ key, label, icon: Icon, match }) => (
                      <div key={key} onClick={() => setActiveFilter(key)} style={cardStyle(activeFilter === key)}>
                          <div style={iconBoxStyle}><Icon size={16} color="#fff" /></div>
                          <div>
                              <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 11 }}>{label}</div>
                              <div style={{ color: '#fff', fontSize: 24, fontWeight: 700, lineHeight: 1.1 }}>
                                  {journals.filter(match).length}
                              </div>
                          </div>
                      </div>
                  ))}
              </div>
          </div>

          {/* Table */}
          <div style={{
              margin: '16px 24px', backgroundColor: '#fff',
              borderRadius: 12, overflow: 'hidden',
              boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          }}>
              {loading ? (
                  <div style={{
                      display: 'flex', flexDirection: 'column',
                      alignItems: 'center', justifyContent: 'center',
                      padding: 60, gap: 14,
                  }}>
                      <Spinner animation="grow" variant="success" style={{ width: 48, height: 48 }} />
                      <div style={{ color: '#6c757d', fontSize: 14 }}>กำลังโหลดข้อมูล...</div>
                  </div>
              ) : (
                  <Tablejournallistrecieved values={journalList} requireConfirm />
              )}
          </div>
      </div>
  )
}

export default Journallistconfirmproduct
